import * as React from 'react'
import { StripeSubscriptionMainConnected } from './StripeSubscriptionMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const StripeSubscriptionMainExamples = () => {
  return (
    <div className="StripeSubscriptionMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <StripeSubscriptionMainConnected />
      </Provider>
    </div>
  )
}
